import { Box, Button, Center, Divider, Group, Modal, Stack, Text } from '@mantine/core'
import { useEffect, useRef, useState } from 'react'
import { QRCodeCanvas } from 'qrcode.react'
import { Toast } from 'antd-mobile'

interface WechatPayQRCodeModalProps {
  opened: boolean
  onClose: () => void
  url: string
}

const StepItem = ({ num, text }: { num: number; text: string }) => (
  <Group gap="sm" align="center">
    <Box
      style={{
        width: 24,
        height: 24,
        borderRadius: '50%',
        backgroundColor: '#07C160',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Text size="xs" c="white" fw={600}>
        {num}
      </Text>
    </Box>
    <Text size="sm" c="gray.7">
      {text}
    </Text>
  </Group>
)

export default function WechatPayQRCodeModal({ opened, onClose, url }: WechatPayQRCodeModalProps) {
  const [qrImageUrl, setQrImageUrl] = useState('')
  const canvasRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (opened && url) {
      setQrImageUrl('')
      setTimeout(() => {
        const canvas = canvasRef.current?.querySelector('canvas')
        if (canvas) {
          setQrImageUrl(canvas.toDataURL('image/png'))
        }
      }, 100)
    }
  }, [opened, url])

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url)
      Toast.show('链接已复制，请打开微信粘贴访问')
    } catch {
      Toast.show('复制失败，请手动复制')
    }
  }

  return (
    <Modal opened={opened} onClose={onClose} title={null} centered size="sm" withCloseButton={false}>
      <Stack gap="lg" py="xs">
        <Box
          style={{
            backgroundColor: '#f8f9fa',
            borderRadius: 12,
            padding: 16,
          }}
        >
          <Stack gap="sm">
            <StepItem num={1} text="长按下方二维码，保存到相册" />
            <StepItem num={2} text="打开微信，点击右上角「+」→「扫一扫」" />
            <StepItem num={3} text="点击右下角「相册」，选择刚保存的二维码" />
          </Stack>
        </Box>

        <Center>
          <Box
            style={{
              padding: 12,
              backgroundColor: '#fff',
              borderRadius: 12,
              border: '2px dashed #07C160',
            }}
          >
            {qrImageUrl ? (
              <img src={qrImageUrl} alt="支付二维码" style={{ width: 180, height: 180, display: 'block' }} />
            ) : (
              <div ref={canvasRef}>
                <QRCodeCanvas value={url || 'loading'} size={180} />
              </div>
            )}
          </Box>
        </Center>

        <Text size="xs" c="dimmed" ta="center">
          长按上方二维码保存
        </Text>

        <Divider />

        <Text size="xs" c="dimmed" ta="center" style={{ cursor: 'pointer' }} onClick={handleCopyLink}>
          长按无法保存？
          <Text span c="blue" size="xs">
            点击复制链接
          </Text>
        </Text>

        <Button variant="subtle" color="gray" size="sm" onClick={onClose}>
          取消支付
        </Button>
      </Stack>
    </Modal>
  )
}
